/**
 * Application Configuration
 * Centralized configuration with proper typing
 */

/**
 * Application version
 */
export const APP_VERSION = '1.2.2' as const

/**
 * Base URL for the application
 */
export const BASE_URL = 'https://transporters.webtitans.gr' as const

/**
 * API base URL
 */
export const API_BASE_URL = `${BASE_URL}/api` as const

/**
 * Mapbox access token for maps functionality
 */
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiY2tlc2lzaXM5NCIsImEiOiJjbTFuZW4yazMwdGw0MmpzZ2oxeDNjeG96In0.BbQOs-QOf7TnHR6GmMhcTg' as const

/**
 * Environment configuration
 */
export const ENV = {
	isDevelopment: process.env.NODE_ENV === 'development',
	isProduction: process.env.NODE_ENV === 'production',
	isTest: process.env.NODE_ENV === 'test',
} as const

/**
 * Application configuration object
 */
export const APP_CONFIG = {
	version: APP_VERSION,
	baseUrl: BASE_URL,
	apiBaseUrl: API_BASE_URL,
	mapbox: {
		accessToken: MAPBOX_ACCESS_TOKEN,
	},
	env: ENV,
} as const

export default APP_CONFIG





